import { useCallback, useEffect, useState } from 'react';
import { useDynamoUtils } from '../context/DynamoUtilsContext';

/**
 * Hook to load and store tutor session history.
 * @param {string} userId - Cognito user ID
 * @param {string} conversationType - type of conversation (tutor, homework, etc)
 * @param {string} tableName - DynamoDB table name
 */
export default function useSessionHistory(userId, conversationType = 'tutor', tableName = 'ai-math-tutor-conversations') {
  const dynamoUtilsRef = useDynamoUtils();
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchHistory = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const dynamoUtils = dynamoUtilsRef.current;
      if (!dynamoUtils || !userId) {
        setHistory([]);
        return;
      }
      const sessions = await dynamoUtils.listConversations(userId, conversationType, tableName);
      setHistory(sessions || []);
    } catch (err) {
      console.error('[useSessionHistory] Failed to fetch sessions:', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [userId, conversationType, tableName]);

  useEffect(() => {
    if (userId) fetchHistory();
  }, [userId, fetchHistory]);

  return { sessionHistory: history, fetchSessionHistory: fetchHistory, isLoadingHistory: loading, historyError: error };
}
